import { render } from "./ContactDetailItem.vue?vue&type=template&id=063d18b5&scoped=true&ts=true"
import script from "./ContactDetailItem.vue?vue&type=script&lang=ts"
export * from "./ContactDetailItem.vue?vue&type=script&lang=ts"

import "./ContactDetailItem.vue?vue&type=style&index=0&id=063d18b5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063d18b5"]])

export default __exports__